export default ({ initialPicked = [], reducedRate } = {}) => ({
  picked: [...initialPicked],
  reducedRate,

  toggle(select) {
    const id = Number(select.dataset.taskId)
    const isReduced = Number(select.value) === this.reducedRate

    this.picked = isReduced
      ? [...this.picked, id]
      : this.picked.filter((x) => x !== id)
  },

  get any() {
    return this.picked.length > 0
  },
})
